import { HeroUIProvider } from '@/components/ui';
import ChurchAILayout from '@/components/layout';
import { AuthProvider } from '@/providers/auth';
import { FirebaseProvider } from '@/providers/firebase';
import { UsersStoreProvider } from '@/store/users';
import { PeopleStoreProvider } from '@/store/people';
import { OrgStoreProvider } from '@/store/org';
import { ConfigProvider } from '@/hooks/config';
import { AppBarProvider } from '@/hooks/appbar';
import { NavigationProvider } from '@/hooks/navigation';
import { GroupsStoreProvider } from '@/store/groups';
import '@/wdyr';
import { AccessStoreProvider } from '@/store/access';
import { MemberStatusStoreProvider } from '@/store/memberstatus';
import { RemindersStoreProvider } from '@/store/reminders';
import { TagsStoreProvider } from '@/store/tags';
import { ReminderModalProvider } from '@/components/reminders/context';
import { CommentModalProvider } from '@/components/comments/context';
import { MentionsStoreProvider } from '@/store/mentions';
import { PersonDrawer } from '@/components/drawer';
import { DrawerProvider } from '@/store/drawer';
import { useNavigate, useHref } from 'react-router-dom';
import Routes from '@/pages/routes';
import { loadConfig, loadFirebaseConfig } from '@/lib/config';
import '@/styles/globals.css';
import { MilestonesStoreProvider } from '@/store/milestones';
import { MilestoneModalProvider } from '@/components/milestones/context';
import { MetricsStoreProvider } from '@/store/metrics';
import { ProfileModalProvider } from '@/components/profile/context';
import { TagsModalProvider } from '@/components/profile/context';

export default function App() {
  const navigate = useNavigate();
  const firebaseConfig = loadFirebaseConfig();
  const appConfig = loadConfig();

  return (
    <AppBarProvider>
      <NavigationProvider>
        <HeroUIProvider navigate={navigate} useHref={useHref}>
          <FirebaseProvider firebaseConfig={firebaseConfig}>
            <ConfigProvider config={appConfig}>
              <AuthProvider>
                <UsersStoreProvider>
                  <OrgStoreProvider>
                    <GroupsStoreProvider>
                      <AccessStoreProvider>
                        <MemberStatusStoreProvider>
                          <PeopleStoreProvider>
                            <MilestonesStoreProvider>
                              <RemindersStoreProvider>
                                <TagsStoreProvider>
                                  <ReminderModalProvider>
                                    <CommentModalProvider>
                                      <MentionsStoreProvider>
                                        <MilestoneModalProvider>
                                          <MetricsStoreProvider>
                                            <ProfileModalProvider>
                                              <TagsModalProvider>
                                                <DrawerProvider>
                                                  <ChurchAILayout>
                                                    <Routes />
                                                    <PersonDrawer />
                                                  </ChurchAILayout>
                                                </DrawerProvider>
                                              </TagsModalProvider>
                                            </ProfileModalProvider>
                                          </MetricsStoreProvider>
                                        </MilestoneModalProvider>
                                      </MentionsStoreProvider>
                                    </CommentModalProvider>
                                  </ReminderModalProvider>
                                </TagsStoreProvider>
                              </RemindersStoreProvider>
                            </MilestonesStoreProvider>
                          </PeopleStoreProvider>
                        </MemberStatusStoreProvider>
                      </AccessStoreProvider>
                    </GroupsStoreProvider>
                  </OrgStoreProvider>
                </UsersStoreProvider>
              </AuthProvider>
            </ConfigProvider>
          </FirebaseProvider>
        </HeroUIProvider>
      </NavigationProvider>
    </AppBarProvider>
  );
}
